namespace advisorop.components.servicer {

    export class AccountMappingServicerController {

        $router;
        title: domains.ITitle;
        investors: Array<domains.IInvestor> = [];
        // account 
        ppAccount: domains.IPPAccountProfile;
        account: domains.IAccount = { id: 0,};
        selTitleType: domains.ILOV;
        selTitleSubtype: domains.ILOV;
        lovs: Array<domains.ILOV> = [];
        titleTypes: Array<domains.ILOV> = [];
        titleSubtypes: Array<domains.ILOV> = [];
        advisorFirmId: number;


        // statuses for ladda ...
        updatingAccountLadda: boolean = false;

        pageTitle: string = "Manual account wizard";

        static $inject = ["advisorService", "generalService", "servicerService"];
        constructor(private advisorService: services.AdvisorService,
            private generalService: services.GeneralService, private servicerService: services.ServicerService) {
        


        }

        newInvestorSelected(investor: domains.IInvestor): void {

            var inv = this.investors.filter((v, i, a) => {
                return v.id == investor.id;
            });
            if (inv.length === 0)
                this.investors.push(investor);
            else
                toastr.warning("Investor already exists in the account list of investors.");
        };

        titleSelected(title: domains.ITitle): void {
            this.title = title;
        };


        getTitleSubtypes(titleType: number): Array<domains.ILOV> {
            return this.lovs.filter((v, i, a) => {
                return v.lovType == 11 && v.parentId == titleType;
            })
        };

        titleTypeChanged(): void {
            if (this.selTitleType) {

                this.account.titleType = this.selTitleType.value;

                this.titleSubtypes = this.getTitleSubtypes(this.account.titleType);

                if (this.titleSubtypes.length > 0) {
                    this.selTitleSubtype = this.titleSubtypes[0];
                    this.account.titleSubtype = this.selTitleSubtype.value;
                }
            }
            else {
                this.account.titleType = 0;
            }
        };

        titleSubtypeChanged(): void {
            if (this.selTitleSubtype) {
                this.account.titleSubtype = this.selTitleSubtype.value;
            } else {
                this.account.titleSubtype = 0;
            }
        };
        
        removeInvestor(inv: domains.IInvestor): void {
            var ind = this.investors.indexOf(inv);
            if (ind >= 0)
                this.investors.splice(ind, 1);
        };



        openAccount(): ng.IPromise<void> {



            //open account ...
            this.account.titleId = 0;//this.title.id;
            this.account.titleName = "";//this.title.name;
            this.account.usdMarketValue = 0;
            this.account.status = 0;
            this.account.id = 0;

            this.account.investors = this.investors;


            this.updatingAccountLadda = true;

            return this.servicerService.openAccount(this.account, this.advisorFirmId)
                .then((data) => {

                    toastr.success("Account has been successfully mapped.");

                    this.account = data.data;         

                   // this.$router.navigate(['AdvisorAccounts', { accountStatus: 1 }]);
                })
                .finally(() => {
                    this.updatingAccountLadda = false;
                });
        };
        
        loadLovs(): void {
            this.generalService.getLOVs()
                .then((data) => {

                    this.lovs = data;

                    this.titleTypes = this.lovs.filter((value, index, array) => { return value.lovType == 10; });

                }, (reason) => {
                    toastr.error("Error " + reason);
                });
        };

        loadAccount(accountId: number): void {
            this.servicerService.getAccount(accountId)
                .success((data) => {

                    //console.log("Account data loaded... Binding account: " + data.name + " :" + data.id + " Type:" + data.titleType);

                    this.account = data;

                    this.investors = this.account.investors;

                    this.selTitleType = this.titleTypes.filter((v, i, a) => { return v.value == this.account.titleType })[0];

                    this.account.titleType = this.selTitleType.id;

                    this.titleTypeChanged();

                    let tmp = this.titleSubtypes.filter((v, i, a) => { return v.value == this.account.titleSubtype });
                    if (tmp.length > 0)
                        this.selTitleSubtype = tmp[0];

                    //console.log("Account binding completed..." + this.account.name);
                })
                .error((status, data) => {
                    toastr.warning("Account error " + status + " " + data);
                });
        };


        loadPPAccount(ppAccountId: number): void {
            this.servicerService.getPPAccount(ppAccountId)
                .success((data) => {
                    //console.log("PP account data loaded...");
                    this.ppAccount = data;

                    this.account.number = this.ppAccount.accountID;
                    this.account.name = this.ppAccount.acctName;
                    this.account.titleName = this.ppAccount.acctName;

                })
                .error((status, data) => {
                    toastr.warning("PP Account error " + status + " " + data);
                });
        };
    

        $onInit(): void {
            this.loadLovs();
        }

        $routerOnActivate(next, previous) {
            //console.log("ADvisory Firm ID in acc mapp servicer");
            //console.log(next.params.companyGroupId);
            if (next.params.accountId) {
                this.loadAccount(<number>next.params.accountId);
                
            }
            if (next.params.ppAccountId) {
                this.loadPPAccount(<number>next.params.ppAccountId);

            }
            if (next.params.companyGroupId) {
                this.advisorFirmId = next.params.companyGroupId;
            }
            
        }
        
    }
    
    class AccountMappingServicer implements ng.IComponentOptions {

        public bindings: any;
        public controller: any;
        public controllerAs: string;
        public templateUrl: string;

        constructor() {
            this.bindings = {      
                "$router": '<'
            };
            this.controller = AccountMappingServicerController;
            this.controllerAs = "vm";
            this.templateUrl = 'spa/servicer-module/components/account-mapping-servicer.html';
        }
    }
    angular.module(Constants.APP).component("accountMappingServicer", new AccountMappingServicer());
}